<section class="collapsible-section" [class.collapsible-section--collapsed]="collapsed">
  <button type="button" class="collapsible-section__toggle" (click)="toggle()" [attr.aria-expanded]="!collapsed">
    <h2 class="collapsible-section__title">
      <cwc-icon
        *ngIf="icon"
        class="collapsible-section__title-icon"
        data-testid="collapsible-section-title-icon"
        [name]="icon"
        size="12.667px"
      ></cwc-icon>
      {{ title }}
      <ng-container *ngIf="count !== null"> ({{ count }})</ng-container>
    </h2>

    <cwc-icon
      class="collapsible-section__toggle-icon"
      name="arrow-right-single"
      size="1rem"
      color="bright-blue"
      [class.collapsible-section__toggle-icon--expanded]="!collapsed"
    >
    </cwc-icon>
  </button>

  <div class="collapsible-section__content" [class.collapsible-section__content--collapsed]="collapsed">
    <ng-content></ng-content>
  </div>
</section>
